import { EnvironmentTypes } from '@pascal/pascal-core';

const AppDefaultValuesEnum = {
  LANGUAGE: 'en',
  APPLICATION_ID: process.env.REACT_APP_ENV === EnvironmentTypes.Production ? 49 : 72,
};

Object.freeze(AppDefaultValuesEnum);

const AppConstantsEnum = {
  TOKEN: 'token',
  GAME_ID: 'gameid',
  EXIT_URL: 'exiturl',
  ACCESS: 'access',
  PARTNER_ID: 'partnerid',
  LANGUAGE: 'culture',
  LANGUAGE_1: 'language', // if partner don't have LANGUAGE key
  CURRENCY: 'currency',
  USERID: 'userid',
  MODE: 'mode',
};

Object.freeze(AppConstantsEnum);

export { AppDefaultValuesEnum, AppConstantsEnum };
